import { useEffect, useState } from 'react';
export function useMediaQuery(query) {
    const [match, setMatch] = useState(() => typeof window !== 'undefined' && window.matchMedia(query).matches);
    useEffect(() => {
        const mq = window.matchMedia(query);
        const onChange = () => setMatch(mq.matches);
        mq.addEventListener('change', onChange);
        return () => mq.removeEventListener('change', onChange);
    }, [query]);
    return match;
}
export const useIsMobile = () => useMediaQuery('(max-width: 768px)');
